/**
 * HomePage.jsx
 * Root page for the QuitPact platform.
 *
 * This page satisfies all requirements of:
 *   User Story 1.1 — HomePage Value Understanding
 *   AC 1.1.1  — Heading + value prop + 3 benefit tiles, all above the fold
 *   AC 1.1.2  — Single prominent "Check My Relapse Risk" CTA button
 *
 * Composition:
 *   <Navbar />              — top navigation bar
 *   <HeroSection />         — headline, value prop, and CTA button
 *   <FeatureTilesSection /> — three named benefit tiles
 *
 * No authentication is required to view this page (guest-accessible).
 *
 * Team: TA37 - The Coders' Assembly
 */

import React from 'react';
import HeroSection from '../components/home/HeroSection';
import FeatureTilesSection from '../components/home/FeatureTilesSection';
import './HomePage.css';

const HomePage = () => {
  return (
    <main className="home-page" aria-label="QuitPact home">

      {/* -- Above-the-fold: heading + value prop + CTA (AC 1.1.1 & 1.1.2) -- */}
      <HeroSection />

      {/* -- Three named benefit tiles (AC 1.1.1) -- */}
      <FeatureTilesSection />

    </main>
  );
};

export default HomePage;
